import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import TextField from "../../Reusable/TextInput";
import Button from "../../Reusable/Button";
import ComboboxInput from "../../Reusable/ComboboxInput";
import APIS from "../../../constant/Endpoint";
import usePostHook from "../../../customHooks/usePostHook";
import { yupResolver } from "@hookform/resolvers/yup";
import { AddContactForm } from "../../../utils/validationSchemas";
import PhoneNumberField from "../../Reusable/PhoneNumberField";

const CreateContacts = ({
  setIsOpen,
  invalidateQuery,
}: {
  setIsOpen: (val: boolean) => void;
  invalidateQuery: () => void;
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
    getValues,
    setError,
    clearErrors,
    control,
  } = useForm<any>({
    resolver: yupResolver(AddContactForm),
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["contacts"],
  });

  const handleCreate = async (values: any) => {
    const url = APIS.CONTACT;
    const formData = {
      ...values,
      dob: values.dob ? values.dob.toString() : null,
    };

    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        reset();
        setIsOpen(false);
        invalidateQuery();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className={tw`w-full mt-5`}>
      <form
        className={tw`grid grid-cols-1 md:grid-cols-2 gap-4`}
        onSubmit={handleSubmit(handleCreate)}
      >
        <div className={tw`col-span-2`}>
          <ComboboxInput
            url={APIS.CONTACT_GROUP}
            queryKey="contact-groups"
            register={register("group")}
            errors={errors.group}
            name="group"
            props={{ is_active: true }}
            label={
              <div
              // className={tw`my-auto font-semibold flex items-center text-lg`}
              >
                Group Name
              </div>
            }
            setValue={setValue}
            watch={watch}
            placeholder="Search Group Name..."
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
        <TextField
          label={"Full Name"}
          placeholder="Enter Your First Name Here..."
          register={register("full_name")}
          errors={errors.full_name}
        />

        <TextField
          label="Email"
          type="email"
          placeholder="Enter Your Email Here..."
          register={register("email")}
          errors={errors.email}
        />

        <PhoneNumberField
          control={control}
          name="phone_number"
          label={"Phone"}
          errors={errors.phone_number}
          labelWidth={100}
        />
        <TextField
          label="Date Of Birth"
          type="date"
          placeholder="Enter Your Date Of Birth Here..."
          register={register("dob")}
          errors={errors.dob}
        />

        <div className={tw`col-span-2 flex justify-end`}>
          <div className={tw`w-40`}>
            <Button
              label="Create Contact"
              type="submit"
              loading={isPostLoading}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreateContacts;
